// Coupons.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Coupons.css';

function Coupons() {
	const navigate = useNavigate();
	const [coupons, setCoupons] = useState([]);
	const [loading, setLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('available');

	useEffect(() => {
		fetchCoupons();
	}, []);

	const fetchCoupons = async () => {
		setLoading(true);
		try {
			const token = localStorage.getItem('access_token');
			const response = await axios.get(
				'https://api.weartoday.kr/api/orders/coupons/',
				{
					headers: {
						'Authorization': `Bearer ${token}`
					}
				}
			);

			console.log('✅ 쿠폰 응답:', response.data);
			setCoupons(response.data.results || response.data || []);

		} catch (error) {
			console.error('❌ 쿠폰 로딩 실패:', error);
			if (error.response?.status === 401) {
				alert('로그인이 만료되었습니다.');
				navigate('/login');
			}
		} finally {
			setLoading(false);
		}
	};

	const filteredCoupons = coupons.filter(coupon => {
		if (activeTab === 'available') {
			return !coupon.is_used && new Date(coupon.expired_at) > new Date();
		} else if (activeTab === 'used') {
			return coupon.is_used;
		} else {
			return new Date(coupon.expired_at) <= new Date();
		}
	});

	if (loading) {
		return (
			<div className="coupon-page">
				<div className="loading">⏳ 쿠폰을 불러오는 중...</div>
			</div>
		);
	}

	return (
		<div className="coupon-page">
			<div className="coupon-header">
				<h1>쿠폰</h1>
			</div>

			{/* 탭 */}
			<div className="coupon-tabs">
				<button 
					className={`tab-btn ${activeTab === 'available' ? 'active' : ''}`}
					onClick={() => setActiveTab('available')}
				>
					사용가능 ({coupons.filter(c => !c.is_used && new Date(c.expired_at) > new Date()).length})
				</button>
				<button 
					className={`tab-btn ${activeTab === 'used' ? 'active' : ''}`}
					onClick={() => setActiveTab('used')}
				>
					사용완료 ({coupons.filter(c => c.is_used).length})
				</button>
				<button 
					className={`tab-btn ${activeTab === 'expired' ? 'active' : ''}`}
					onClick={() => setActiveTab('expired')}
				>
					기간만료 ({coupons.filter(c => new Date(c.expired_at) <= new Date()).length})
				</button>
			</div>

			{/* 쿠폰 목록 */}
			{filteredCoupons.length === 0 ? (
				<div className="empty-coupons">
					<div className="empty-icon">🎟️</div>
					<p>쿠폰이 없습니다.</p>
				</div>
			) : (
				<div className="coupons-list">
					{filteredCoupons.map(coupon => (
						<div key={coupon.id} className={`coupon-card ${coupon.is_used ? 'used' : ''}`}>
							<div className="coupon-left">
								<div className="coupon-discount">
									{coupon.discount_type === 'percent' 
										? `${coupon.discount_value}%`
										: `${coupon.discount_value.toLocaleString()}원`}
								</div>
								<p className="coupon-min">
									{coupon.min_purchase_amount > 0 
										? `${coupon.min_purchase_amount.toLocaleString()}원 이상 구매 시`
										: '최소 구매금액 없음'}
								</p>
							</div>
							<div className="coupon-right">
								<h3>{coupon.name}</h3>
								<p className="coupon-expire">
									{new Date(coupon.expired_at).toLocaleDateString('ko-KR')} 까지
								</p>
								{coupon.is_used && (
									<span className="used-badge">사용완료</span>
								)}
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
}

export default Coupons;